export interface EventMessage<T> {
  event: "psi-export" | "psi-error" | "psi-set-state" | "psi-mounted";
  data: T;
  sentAt?: number;
}

export interface DrawingMessage {
  shapes: string;
  jpegB64: string;
}

export function sendMessage(msg: EventMessage<any>) {
  msg.sentAt = Date.now();
  window.parent.postMessage(msg, "*");
}

export function parseMessageBody<T>(msg: MessageEvent<any>) {
  return typeof msg.data === "string" && msg.data.indexOf("psi-") !== -1
    ? JSON.parse(msg.data)
    : (msg.data as T);
}

export function isSetStateMessage(msg: EventMessage<DrawingMessage>): boolean {
  return msg.event === "psi-set-state";
}

// TEST RE-INIT
// const TEST_MSG: EventMessage<DrawingMessage> = {
//   event: "psi-set-state",
//   data: {
//     shapes:
//       '[{"id":"9b7832a9-6f54-4842-2297-6c9737885634","type":"draw","name":"Draw","parentId":"page","childIndex":1,"point":[321,171],"rotation":0,"style":{"color":"black","size":"small","isFilled":false,"dash":"draw","scale":1},"points":[[434,3,0.5],[434,3,0.5],[418,0,0.5],[405,0,0.5],[388,1,0.5],[368,5,0.5],[343,12,0.5],[323,21,0.5],[305,34,0.5],[296,49,0.5],[295,63,0.5],[302,74,0.5],[321,90,0.5],[352,109,0.5],[386,127,0.5],[422,149,0.5],[449,168,0.5],[464,186,0.5],[469,209,0.5],[464,236,0.5],[444,271,0.5],[413,307,0.5],[370,342,0.5],[328,370,0.5],[282,392,0.5],[244,406,0.5],[213,415,0.5],[187,417,0.5],[164,417,0.5],[140,413,0.5],[116,405,0.5],[92,395,0.5],[75,384,0.5],[62,375,0.5],[50,367,0.5],[39,360,0.5],[27,351,0.5],[17,340,0.5],[7,324,0.5],[0,310,0.5]],"isComplete":true},{"id":"ede8f9d7-a0cd-4486-01f3-a52919380c30","type":"draw","name":"Draw","parentId":"page","childIndex":2,"point":[260,174],"rotation":0,"style":{"color":"black","size":"small","isFilled":false,"dash":"draw","scale":1},"points":[[266,7,0.5],[266,7,0.5],[266,5,0.5],[265,3,0.5],[261,2,0.5],[248,1,0.5],[223,1,0.5],[187,0,0.5],[145,0,0.5],[107,2,0.5],[72,9,0.5],[45,21,0.5],[25,40,0.5],[17,61,0.5],[15,92,0.5],[30,124,0.5],[65,153,0.5],[116,178,0.5],[180,201,0.5],[248,228,0.5],[296,255,0.5],[331,282,0.5],[352,306,0.5],[360,323,0.5],[363,337,0.5],[365,351,0.5],[365,363,0.5],[363,377,0.5],[356,393,0.5],[339,416,0.5],[318,438,0.5],[303,457,0.5],[298,473,0.5],[303,483,0.5],[317,494,0.5],[336,508,0.5],[355,521,0.5],[367,535,0.5],[369,545,0.5],[367,553,0.5],[359,561,0.5],[342,572,0.5],[312,581,0.5],[232,587,0.5],[175,589,0.5],[118,587,0.5],[65,579,0.5],[23,568,0.5],[0,557,0.5]],"isComplete":true}]',
//     jpegB64: "",
//   },
// };
// setTimeout(() => {
//   sendMessage(TEST_MSG);
// }, 2000);
